/**
 * ScrollToTop Component
 *
 * Resetta lo scroll della pagina ad ogni cambio di route.
 * Da inserire dentro BrowserRouter.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
